<template>
  <div>
    <header-view @same-router="sameRouter"></header-view>
    <div id="content" class="content-box">
      <div class="content-banner"></div>
      <div class="table-content news-table-content">
        <div class="table-box f-cb">
          <div id="news">
            <ul id="news_toggle" class="nav f-fl">
              <li class="title">
                <h2>新闻中心</h2>
                <span class="tip">NEWS CENTER</span>
              </li>
              <li @click="handlChangeTab('list')" :class="{'active': item === 'list' || item === 'detail'}">公告/声明</li>
            </ul>

            <div id="news_container">

              <!-- 公告列表 -->
              <div v-if="item === 'list'" class="content f-fr">
                <div class="title f-cb">
                  <h3 class="f-fl">公告</h3>
                  <span class="des f-fr">
                    您的位置：首页 > 新闻中心 > <span>公告</span>
                  </span>
                </div>
                <div class="con">
                  <div class="article-list">
                    <div class="article-item" @click="handlChangeTab('detail')">
                      <div class="article-title">关于公章被冒用及虚假合同的免责声明</div>
                      <div class="article-date">2026-04-13</div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- 文章详情 -->
              <div v-if="item === 'detail'" class="content f-fr">
                <div class="title f-cb">
                  <h3 class="f-fl">公告</h3>
                  <span class="des f-fr">
                    您的位置：首页 > 新闻中心 > <span @click="handlChangeTab('list')" style="cursor:pointer;color:#c0c0c0;">公告</span> > <span>免责声明</span>
                  </span>
                </div>
                <div class="con">
                  <div class="back-btn" @click="handlChangeTab('list')">← 返回列表</div>
                  <div class="art-title">上海传发金融信息服务有限公司</div>
                  <div class="art-sub">关于公章被冒用及虚假合同的免责声明</div>
                  <div class="art-meta">发布日期：2026年4月13日</div>
                  <div class="art-body">
                    <p style="text-indent:2em">近日，我司严正发现：有外部公司及不法主体伪造、冒用我司公章，以我司名义对外签订虚假合同、开展非法经营活动。该行为已严重侵害我司合法权益、损害公司声誉，并涉嫌违法犯罪。为维护合作伙伴与社会公众权益，避免各方蒙受损失，我司特此发布如下免责声明：</p>

                    <h3>一、公章使用与效力说明</h3>
                    <p style="text-indent:2em">我司唯一合法有效公章，系经公安机关正规备案、由公司专人严格保管、按制度审批使用；任何未经我司书面授权、非我司正规用印流程出具的公章、合同章、文件均为伪造或冒用，自始无效，对我司不产生法律约束力。</p>

                    <h3>二、免责与责任界定</h3>
                    <p style="text-indent:2em">凡以伪造、冒用我司公章签订的虚假合同、协议、承诺、函件等一切法律文件，均非我司真实意思表示，我司不承担任何履约责任、付款义务、赔偿责任及其他法律责任。由此产生的一切纠纷、损失与法律后果，均由伪造、冒用主体及相关签约方自行承担。</p>

                    <h3>三、冒用公章的法律后果</h3>
                    <p style="text-indent:2em">伪造、冒用公司公章属于严重违法行为，相关主体将依法承担以下法律责任：</p>
                    <ol style="margin-left:2em">
                      <li><strong>刑事责任：</strong>依据《中华人民共和国刑法》第二百八十条，伪造公司印章可构成伪造公司印章罪，处三年以下有期徒刑、拘役、管制或者剥夺政治权利，并处罚金；以非法占有为目的使用假章签订合同骗取财物，还可能构成合同诈骗罪，依法追究刑事责任。</li>
                      <li><strong>民事责任：</strong>依据《中华人民共和国民法典》及相关司法解释，伪造、冒用公章所签订的合同无效，行为人应自行承担返还财产、赔偿损失等全部民事责任；我司无任何过错，不承担任何民事赔偿责任。</li>
                      <li><strong>行政责任：</strong>公安机关可依法给予拘留、罚款等治安管理处罚；市场监管部门可依法没收违法所得、处以罚款、吊销相关证照等行政处罚。</li>
                    </ol>

                    <h3>四、我司已采取的法律措施</h3>
                    <p style="text-indent:2em">我司已就公章被伪造、冒用及虚假合同事宜固定证据并向公安机关报案，同步启动民事追责与全面法律维权程序，坚决追究相关方的刑事、行政与民事法律责任，绝不姑息。</p>

                    <h3>五、郑重提醒与核实渠道</h3>
                    <p style="text-indent:2em">请各合作方、社会公众提高警惕，凡涉及我司业务合作、合同签署、款项往来等事项，务必通过我司官方渠道核实确认，切勿轻信非官方信息与非正规文件，谨防上当受骗。</p>
                    <p style="text-indent:2em"><strong>官方核实联系方式：【021-38750106】</strong></p>

                    <h3>六、声明效力</h3>
                    <p style="text-indent:2em">本声明自发布之日起生效，面向社会公众公示，具有告知、警示与免责的法律效力。任何单位或个人继续与伪造、冒用主体以我司名义开展交易的，相关风险与责任自行承担。</p>
                    <p><strong>特此声明！</strong></p>

                    <div class="art-footer">
                      <p>上海传发金融信息服务有限公司</p>
                      <p>2026年4月13日</p>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
    <footer-view></footer-view>
  </div>
</template>

<script>
import HeaderView from '@/components/header.vue'
import FooterView from '@/components/footer.vue'

export default {
  name: 'newsView',
  data() {
    return {
      item: 'list'
    }
  },
  created() {
    this.item = this.$route.params.item || 'list'
  },
  methods: {
    handlChangeTab(tab) {
      this.item = tab
    },
    sameRouter(params) {
      this.handlChangeTab(params.item)
    }
  },
  components: { HeaderView, FooterView }
}
</script>

<style lang="stylus">
color = #f37a55;

.content-box {
  .news-table-content {
    min-height: calc(100vh - 400px);
  }

  .content-banner {
    width: 100%;
    height: 290px;
    background: url('../assets/images/banner2.png') no-repeat;
    background-size: cover;
    background-position: center;
  }

  .table-content {
    width: 100%;
    padding-bottom: 130px;

    .table-box {
      width: 1200px;
      margin: 0px auto;
      margin-top: -34px;
    }
  }
}

.table-box {
  .nav {
    width: 234px;

    .title {
      h2 {
        margin: 10px 0;
      }

      width: 100%;
      height: 122px;
      font-size: 22px;
      color: white;
      background-color: color;
      padding: 26px;

      .tip {
        color: #f8a084;
      }
    }

    .active {
      border-left: 2px solid color;
      background-color: #f3f3f3;
    }

    li+li {
      cursor: pointer;
      position: relative;
      line-height: 32px;
      height: 64px;
      border-left: 1px solid #d5d5d5;
      border-right: 1px solid #d5d5d5;
      border-bottom: 1px solid #d5d5d5;
      padding: 16px;

      &:after {
        content: '';
        position: absolute;
        width: 0;
        height: 0;
        border-top: 6px solid #d5d5d5;
        border-left: 6px solid transparent;
        right: 10px;
        top: 50%;
        transform: rotate(45deg) translateY(-50%);
      }
    }
  }

  .content {
    width: 947px;
    padding: 1px 42px 70px;
    background-color: white;
    border: 1px solid #d5d5d5;

    >.title {
      padding: 22px 0;
      height: 64px;
      border-bottom: 1px solid #d5d5d5;

      h3 {
        font-size: 18px;
        font-weight: normal;
        padding-left: 10px;
        height: 20px;
        line-height: 20px;
        width: 200px;
        color: #bdbcbd;
        border-left: 8px solid color;
      }

      .des {
        color: #c0c0c0;

        span {
          color: #D45A1A;
        }
      }
    }

    .con {
      line-height: 26px;
    }
  }
}

#news {
  .article-list {
    padding-top: 10px;

    .article-item {
      border-bottom: 1px dashed #e0e0e0;
      padding: 18px 0;
      cursor: pointer;
      display: flex;
      justify: space-between;
      align-items: center;
      transition: color 0.2s;

      &:hover .article-title {
        color: color;
      }

      .article-title {
        flex: 1;
        font-size: 15px;
        color: #333;

        &:before {
          content: '■';
          color: color;
          font-size: 8px;
          margin-right: 8px;
        }
      }

      .article-date {
        font-size: 13px;
        color: #999;
        flex-shrink: 0;
        margin-left: 20px;
      }
    }
  }

  .back-btn {
    display: inline-flex;
    align-items: center;
    color: color;
    font-size: 14px;
    cursor: pointer;
    margin-bottom: 24px;
    padding: 6px 14px;
    border: 1px solid color;
    border-radius: 3px;
    transition: all 0.2s;

    &:hover {
      background: color;
      color: #fff;
    }
  }

  .art-title {
    font-size: 22px;
    font-weight: bold;
    color: #222;
    text-align: center;
    margin-bottom: 8px;
  }

  .art-sub {
    font-size: 15px;
    color: #555;
    text-align: center;
    margin-bottom: 6px;
  }

  .art-meta {
    text-align: center;
    font-size: 13px;
    color: #999;
    margin-bottom: 28px;
    padding-bottom: 20px;
    border-bottom: 1px solid #eee;
  }

  .art-body {
    font-size: 15px;
    line-height: 2;
    color: #444;

    p {
      margin-bottom: 14px;
    }

    h3 {
      font-size: 15px;
      font-weight: bold;
      color: #222;
      margin: 20px 0 10px;
    }

    ol {
      margin: 10px 0 10px 20px;

      li {
        margin-bottom: 10px;
      }
    }
  }

  .art-footer {
    margin-top: 32px;
    text-align: right;
    font-size: 15px;
    color: #333;
    font-weight: bold;

    p {
      margin-bottom: 4px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/news.vue